import React, { useState, useEffect } from 'react'
import { Table, Spin, Avatar, Button } from 'antd'
import { useNavigate } from 'react-router-dom'

import Layout from '../../components/layout/Layout'
import axiosInstance from '../../utils/axiosInstance'

function LoginLogoutLogs() {
  const navigate = useNavigate()

  const [loading, setLoading] = useState(false)
  const [logs, setLogs] = useState([])

  const getLogs = async (v) => {
    try {
      setLoading(true)

      const response = await axiosInstance.get(`/api/v1/logs/getLogs`)

      setLogs(response.data.logs)
      // console.log(response.data.logs)
      setLoading(false)
    } catch (e) {
      console.log(e)
      setLoading(false)
    }
  }

  useEffect(() => {
    getLogs()
  }, [])

  const columns = [
    {
      title: 'Message',
      dataIndex: 'message',
      key: 'message',
      responsive: ['xs', 'sm', 'md', 'lg', 'xl'],
      render: (_, record) => (
        <div>
          {record.userDetails?.profilePicture && <Avatar src={record.userDetails?.profilePicture} style={{ margin: 20 }} />}
          {record.message}
        </div>
      ),
    },
    {
      title: 'Date',
      dataIndex: 'createdAt',
      key: 'createdAt',
      render: (text) => new Date(text).toLocaleString(),
      responsive: ['xs', 'sm', 'md', 'lg', 'xl'],
    },
  ]

  return (
    <Layout>
      <div style={{ padding: '20px' }}>
        <h2>Logs</h2>
        <Button onClick={() => navigate(-1)} style={{ marginBottom: 20 }} type="primary">
          Back
        </Button>
        {loading ? (
          <Spin />
        ) : (
          <>
            <p>Count: {logs.length}</p>

            <Table columns={columns} dataSource={logs} pagination={{ pageSize: 20 }} scroll={{ x: 300 }} />
          </>
        )}
      </div>
    </Layout>
  )
}

export default LoginLogoutLogs
